module.exports = __webpack_public_path__ + "static/media/cashflow-up-btn.dcdee42e.svg";